function ControlRegistrationRequest(params, cid) {
    this.params = params;
    this.cid = cid;
}

module.exports = ControlRegistrationRequest;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/control-registration-request.js
// module id = 305
// module chunks = 1